import { TableCell, TableRow, Theme, Typography } from "@mui/material";
import { OrderListObj } from "../../redux-store/types/orderManagement";
import dayjs from "dayjs";
import { ColorMap } from "../investorOverview/types";
import { useHistory } from "react-router-dom";

const colorMap: ColorMap = {
    approved: "success.500",
    "approved by checker": "success.500",
    "approved by payment checker": "success.500",
    "rejected by payment checker": "error.500",
    rejected: "error.500",
    "rejected by checker": "error.500",
    pending: 'warning.500'
}
export default function OrdersApprovalTableBody({ data }: { data: Array<OrderListObj> }): JSX.Element {
    const history = useHistory();

    const handleOrderDetails = (productOrderTableId: string, productType: string, id: string | number, cartId: string | number, orderStatus: string) => {
        history.push('/order-details', {
            productOrderId: productOrderTableId,
            product: productType,
            id,
            cartId,
            orderStatus
        });
    }
    return (
        <>
            {data?.map((obj: OrderListObj) => {

                return (
                    <TableRow
                        key={obj.orderNumber}
                        sx={(theme: Theme) => ({
                            '& td': {
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            },
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        })}
                    >
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.orderNumber ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {dayjs(obj?.orderDate ?? "-").format("DD/MM/YYYY")}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.clientName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.productType ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary
                                })}
                            >
                                {obj?.portfolioName ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.text.primary,
                                })}
                            >
                                {obj?.accountType ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.paymentStatus?.toLowerCase()] ? colorMap[obj?.paymentStatus?.toLowerCase()] : theme.palette.text.primary,
                                })}
                            >
                                {obj?.paymentStatus ?? "-"}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px",
                                    color: colorMap[obj?.approvalStatus?.toLowerCase()] ? colorMap[obj?.approvalStatus?.toLowerCase()] : theme.palette.text.primary,
                                    cursor: 'pointer'
                                })}
                                onClick={() => handleOrderDetails(obj?.productOrderTableId ?? '', obj?.productType ?? '', obj?.id ?? '', obj?.cartId ?? '', obj?.approvalStatus ?? '')}
                            >
                                {obj?.approvalStatus ?? "-"}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>

    )
}
